<template>
    <div id="notice-messages" class="notice-messages">
        <sticky-messages v-if="stickyMessages.length > 0 && !hideSticky" :messages="stickyMessages"></sticky-messages>
        <non-sticky-messages @message-changed="messageChanged" :stickyHeight="stickyHeight" v-if="noticeMessages.length > 0" :noticeBoard="noticeBoard" :messages="noticeMessages"></non-sticky-messages>
    </div>
</template>

<script>
    import Vue from 'vue'
    import StickyMessages from './sticky-messages';
    import NoticeMessages from './non-sticky-messages';
    import moment from 'moment';

    Vue.component('sticky-messages', StickyMessages);
    Vue.component('non-sticky-messages', NoticeMessages);

    export default {
        data() {
            return {
                stickyMessages: {},
                noticeMessages: {},
                sheduleInterval: {},
                nextMessages: {},
                rerenderRequired: {},
                stickyHeight: {},
                hideSticky:false
            }
        },
        methods: {
            messageChanged(noticeMessage) {
                if (!noticeMessage.sticky && noticeMessage.fullScreen)
                    this.hideSticky = true;
                else
                    this.hideSticky = false;

                this.$emit("message-changed", noticeMessage);

            },
            separateMessages: function (forceRerender) {
                this.nextMessages = [];
                this.rerenderRequired = false;

                if (forceRerender === true)
                    this.rerenderRequired = true;

                for (var i = 0; i < this.messages.length; i++) {
                    setTimeout(this.checkMessage, i, this.messages[i]);
                }
            },
            checkMessage: function (message) {
                var currentDate = moment();

                var isActive = (message.beginDateTime == null || moment(message.beginDateTime).isBefore(currentDate)) && (message.expiryDateTime == null || moment(message.expiryDateTime).isAfter(currentDate));

                if (!isActive) {
                    setTimeout(this.addMessageDetails, 0, message, false);
                    return;
                }

                var dayValid = true;
                var frequencyValid = true;

                if (message.recurringPeriod == 0) {
                    var endDay = moment().day(message.recurringDay + message.recurringDuration - 1).day();
                    dayValid = endDay < message.recurringDay ? currentDate.day() >= message.recurringDay || endDay >= currentDate.day() : currentDate.day() >= message.recurringDay && endDay >= currentDate.day()
                    if (dayValid) {
                        frequencyValid = currentDate.diff(message.beginDateTime, 'week') % message.recurringFrequency == 0
                    }
                } else if (message.recurringPeriod == 1) {
                    var endDay = moment().date(message.recurringDay + message.recurringDuration - 1).date();
                    dayValid = endDay < message.recurringDay ? currentDate.date() >= message.recurringDay || endDay >= currentDate.date() : currentDate.date() >= message.recurringDay && endDay >= currentDate.date()
                    if (dayValid) {
                        frequencyValid = currentDate.diff(message.beginDateTime, 'month') % message.recurringFrequency == 0
                    }
                }

                if (isActive && dayValid && frequencyValid) {
                    setTimeout(this.addMessageDetails, 0, message, true);
                } else {
                    setTimeout(this.addMessageDetails, 0, message, false);
                }

            },
            addMessageDetails: function (message, showMessage) {
                var sticky = message.sticky;

                if (!this.rerenderRequired) {
                    var currentMessage = sticky ? this.stickyMessages.find(m => m.noticeMessageId == message.noticeMessageId) : this.noticeMessages.find(m => m.noticeMessageId == message.noticeMessageId);

                    if (currentMessage) {
                        if (message.updatedDateTime !== currentMessage.updatedDateTime)
                            this.rerenderRequired = true;                        

                       // var picturesMatch = this.comparePictures(message, currentMessage);

                       //if (!picturesMatch)
                       //     this.rerenderRequired = true;
                    }
                }

                if (!this.rerenderRequired) {
                    if (sticky) {
                        var messageShownAlready = (this.stickyMessages.findIndex(m => m.noticeMessageId == message.noticeMessageId) != -1);
                        if (this.stickyMessages == null || messageShownAlready != showMessage)
                            this.rerenderRequired = true;
                    } else {
                        var messageShownAlready = (this.noticeMessages.findIndex(m => m.noticeMessageId == message.noticeMessageId) != -1)
                        if (this.noticeMessages == null || messageShownAlready != showMessage)
                            this.rerenderRequired = true;
                    }
                }

                this.nextMessages.push({
                    "noticeMessageId": message.noticeMessageId,
                    "displayNow": showMessage,
                    "sticky": sticky
                });
                if (this.nextMessages.length == this.messages.length) {
                    setTimeout(this.separateStickyMessages, 0);
                }
            },
            //comparePictures: function (message, currentMessage) {

            //    var currentPictures = currentMessage.pictures;
            //    var newPictures = message.pictures;

            //    if (currentPictures === newPictures) return true;
            //    if (currentPictures == null || newPictures == null) return false;
            //    if (currentPictures.length !== newPictures.length) return false;

            //    for (var i = 0; i < currentPictures.length; i++) {
            //        if (newPictures.findIndex(m => m.noticePictureId == currentPictures[i].noticePictureId) == -1)
            //            return false;
            //    }

            //    for (var i = 0; i < newPictures.length; i++) {
            //        if (currentPictures.findIndex(m => m.noticePictureId == newPictures[i].noticePictureId) == -1)
            //            return false;
            //    }
            //    return true;
            //},
            separateStickyMessages: function () {
                var nonStickyMessages = this.nextMessages.filter(function (msg) {
                    var sticky = msg.sticky;
                    var displayNow = msg.displayNow;
                    return !sticky && displayNow
                });

                var stickyMessages = this.nextMessages.filter(function (msg) {
                    var sticky = msg.sticky;
                    var displayNow = msg.displayNow;
                    return sticky && displayNow
                });

                setTimeout(this.checkForChanges, 0, nonStickyMessages, stickyMessages);
            },
            checkForChanges: function (nonStickyMessages, stickyMessages) {
                if (!this.rerenderRequired)
                    this.rerenderRequired = this.checkMessagesRemoved(stickyMessages, nonStickyMessages);

                if (!this.rerenderRequired)
                    this.rerenderRequired = this.checkForOrderChange(nonStickyMessages);

                if (this.rerenderRequired) {
                    console.log("rerender required");
                    setTimeout(this.getNewMessageIds, 0, nonStickyMessages, stickyMessages);
                } else {
                    console.log("rerender not required");
                }
            },
            getNewMessageIds: function (nonStickyMessages, stickyMessages) {
                var nonStickyIds = nonStickyMessages.map(function (message) { return message.noticeMessageId; });
                var stickyIds = stickyMessages.map(function (message) { return message.noticeMessageId; });

                setTimeout(this.getNewMessages, 0, nonStickyIds, stickyIds);
            },
            getNewMessages: function (nonStickyIds, stickyIds) {
                var newNoticeMessages = this.messages.filter(m => nonStickyIds.includes(m.noticeMessageId));
                var newStickyMessages = this.messages.filter(m => stickyIds.includes(m.noticeMessageId));

                setTimeout(this.showNewMessages, 0, newNoticeMessages, newStickyMessages);
            },
            checkForOrderChange: function (nonStickyMessages) {
                for (var i = 0; i < this.noticeMessages.length; i++) {
                    if (nonStickyMessages.find(m => m.noticeMessageId == this.noticeMessages[i].noticeMessageId).order != this.noticeMessages[i].order)
                        return true;
                }

                return false;
            },
            showNewMessages: function (newNoticeMessages, newStickyMessages) {
                console.log("showing new messages");                 

                this.noticeMessages = newNoticeMessages.sort(function (a, b) { return a.order - b.order });

                if (this.noticeBoard.transition == 0) {
                    this.addDash();
                }

                this.stickyMessages = newStickyMessages;
                this.$nextTick(this.setStickyHeight);
                //this.$nextTick(this.autosizeText);
            },
            setStickyHeight: function () {
                this.stickyHeight = $(".sticky-wrapper").length > 0 ? $(".sticky-wrapper").outerHeight(true) : 0;
            },
            checkMessagesRemoved: function (stickyMessages, nonStickyMessages) {
                for (var i = 0; i < this.noticeMessages.length; i++) {
                    if (nonStickyMessages.findIndex(m => m.noticeMessageId == this.noticeMessages[i].noticeMessageId) == -1)
                        return true;
                }

                for (var i = 0; i < this.stickyMessages.length; i++) {
                    if (stickyMessages.findIndex(m => m.noticeMessageId == this.stickyMessages[i].noticeMessageId) == -1)
                        return true;
                }
            },
            addDash: function () {
                this.noticeMessages = this.noticeMessages.map(function (msg) {
                    msg.message = (msg.message === "" || msg.message.slice(0, 1) == "-") ? msg.message : "- " + msg.message;
                    return msg;
                })
            },
            removeDash: function () {
                this.noticeMessages = this.noticeMessages.map(function (msg) {
                    msg.message = msg.message.slice(0, 1) == "-" ? msg.message.slice(2) : msg.message;
                    return msg;
                })
            },
            autosizeText: function () {
                $('.resize').each(function (el) {
                    var el = $(this);
                    var fontsize = 10;

                    el.css("font-size", fontsize + "px");

                    var portrait = window.screen.height > window.screen.width;
                    var parentClasses = ".none-message, .swiper-container, .sticky-message";

                    var width = window.screen.width;
                    var isFhd = width > 1900 || portrait && width > 1000

                    var isBeside = el.parent().hasClass(".rightTextPortrait");
                    console.log(el)
                    console.log(el.closest(".imgTextWrapper").height());
                    console.log(el.closest(".none-message").height())

                    if (portrait && !isBeside) 
                        parentClasses = ".imgTextWrapper," + parentClasses

                    while (el.closest(parentClasses).height() > el.height() && (!isFhd || fontsize <= 120)) {
                        fontsize++;
                        el.css("font-size", fontsize + "px");

                        if (fontsize > 500) {
                            break;
                        }
                    }

                    fontsize--;
                    el.css("font-size", fontsize + "px");
                }
                );
            }

        },
        props: {
            noticeBoard: {
                type: Object
            },
            messages: {

            }
        },
        watch: {
            messages: {
                handler: function () {
                    this.separateMessages(true);
                },
                deep: true
            },
            noticeBoard: function (newBoard, oldBoard) {
                if (oldBoard.transition != 0 && newBoard.transition == 0) {
                    this.addDash();
                } else {
                    this.removeDash();
                }

                

            }
        },
        created() {
            this.noticeMessages = [];
            this.stickyMessages = [];
            this.stickyHeight = 0;
            this.separateMessages();
            this.scheduleInterval = setInterval(this.separateMessages, 300000);
        },
        
        updated() {

        },
        beforeDestroy() {
            clearInterval(this.sheduleInterval);
        }
    }



</script>
<style>

    

    .notice-messages {
       height:100%;
    }

</style>
